import ProgressBar from "@/components/Elements/ProgressBar";
import { ProgressEditForm } from "@/components/ProgressEdit";

const ProgressButton = ({ type, model, isEditable }) => {
  const commonProps = {
    withBorder: true,
    style: { width: "110px" },
  };

  // TODO: DEV-4673 - VALIDATE TYPE CONTRACT, IT'S NOT THE ANTD BUTTON TYPE
  return isEditable ? (
    <ProgressEditForm type={type} model={model} {...commonProps} />
  ) : (
    <ProgressBar value={model?.progress ?? 0} {...commonProps} />
  );
};

export default ProgressButton;
